// ============================================================================
//  zonePalette — wybór palety (zakresu barw) dla STREFY koloru.
//  Strefy płytek (kort/trumna/wybieg/obrzeże) → paleta modelu (tiles.json),
//  strefy linii (lines/linesThree/linesJr) → wspólna paleta 'court-lines' (linie malowane
//  farbą mają własny, stały zakres: białe/żółte/czarne/czerwone — wymóg klientki).
//  Czysty moduł (bez THREE/DOM/import.meta) — testowalny pod Node; używany też
//  przez configCodec i quotePayload (dlatego NIE importuje tileLibrary).
// ============================================================================

const LINE_ZONES = new Set(['lines', 'linesThree', 'linesJr'])
const LINE_PALETTE = 'court-lines'

export function pickZonePalette(catalog, modelId, zoneKey) {
  if (LINE_ZONES.has(zoneKey) && catalog.palettes[LINE_PALETTE]) {
    return catalog.palettes[LINE_PALETTE]
  }
  const model = catalog.models.find((m) => m.id === modelId) || catalog.models[0]
  return catalog.palettes[model.palette] || Object.values(catalog.palettes)[0]
}
